'use client';

import { SpotMarketConfig, BigNum } from '@drift-labs/sdk';
import { MIN_LEFTOVER_SOL } from 'src/constants/constants';
import useCurrentWalletCollateralBalance from './useCurrentWalletCollateralBalance';
import { useAccountCreationCost } from './useAccountCreationCost';

const useTransferableWalletCollateralBalance = (
	bank: SpotMarketConfig,
	isInitialSolDeposit?: boolean,
	maxDecimals?: number
): [BigNum, boolean] => {
	const { totalCost: accountCreationCost } = useAccountCreationCost();
	const [currentBalance, loadingBalance] =
		useCurrentWalletCollateralBalance(bank);

	const minLeftoverSolBigNum = isInitialSolDeposit
		? accountCreationCost.add(MIN_LEFTOVER_SOL)
		: MIN_LEFTOVER_SOL;

	const transferableBalanceBignum =
		bank.symbol === 'SOL'
			? currentBalance.gt(minLeftoverSolBigNum)
				? currentBalance.sub(minLeftoverSolBigNum)
				: new BigNum(0, bank.precisionExp)
			: currentBalance;

	// If maxDecimals is provided, format the balance
	if (maxDecimals !== undefined) {
		const formattedBalance = transferableBalanceBignum
			.toNum()
			.toFixed(maxDecimals);
		return [
			BigNum.fromPrint(formattedBalance, bank.precisionExp),
			loadingBalance,
		];
	}

	return [transferableBalanceBignum, loadingBalance];
};

export default useTransferableWalletCollateralBalance;
